import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from '../actionTypes';
import { loginSuccess, authError } from '../actions';

import * as authAPI from '../../../helpers/api/auth.api';

function* loginUser({ payload: { credentials, history } }) {
	const response = yield call(authAPI.loginUser, credentials);

	if (response.success) {
		localStorage.setItem("authUser", JSON.stringify(response.user));

		yield put(loginSuccess(response.user));

		if (response.user.type === 'admin')
		history.push('/admin/')
		else 
		history.push('/dashboard');
	} else yield put(authError(response.message));
}

function* logoutUser({ payload: { history } }) {
	try {
		localStorage.removeItem('authUser');
		localStorage.removeItem('token');
		history.replace('/login');
	} catch (error) {
		yield put(authError(error));
	}
}

export function* watchUserLogin() {
	yield takeEvery(LOGIN_USER, loginUser);
}

export function* watchUserLogout() {
	yield takeEvery(LOGOUT_USER, logoutUser);
}

function* authSaga() {
	yield all([fork(watchUserLogin), fork(watchUserLogout)]);
}

export default authSaga;
